import { schema } from 'normalizr';

export const tagSchema = new schema.Entity('tag', {}, { idAttribute: '_id' });
export const tagListSchema = [tagSchema];
